import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { useParams } from 'react-router-dom'

import MenuItem from './MenuItem'
import TinyIcon from 'components/shared/TinyIcon'

import iconExpand from 'assets/icons/ico-expand.svg'

const RotatedIcon = props => props.expanded && css`
  transform: scale(0.3) rotate(450deg);
`

const Icon = styled(TinyIcon)`
  transition: transform .5s ease;

  ${RotatedIcon}
`

const SubmenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

const Submenu = ({ title, list, isExpanded }) => {
  //router logic
  const historyParams = useParams()
  const isAnyItemActive = list.some(item => (
    item.filterType === historyParams.filterType &&
    item.route === historyParams.filterId
  ))

  //state logic
  const [expanded, setExpanded] = useState(isExpanded)

  return (
    <React.Fragment>
      <SubmenuHeader
        onClick={() => {
          setExpanded(!expanded)
        }}
      >
        <Icon expanded={(expanded || isAnyItemActive)} src={iconExpand} />
        {title}
      </SubmenuHeader>
      {(expanded || isAnyItemActive) && list.map((menuItem, idx) => (
        <MenuItem
          route={menuItem.route}
          filterType={menuItem.filterType}
          onClick={menuItem.onClick}
          title={menuItem.title}
          key={idx}
          counter={menuItem.counter}
        />
      ))}
    </React.Fragment>
  )
}

Submenu.propTypes = {
  title: PropTypes.string,
  isExpanded: PropTypes.bool,
  list: PropTypes.array
}

export default Submenu
